import { Component, OnInit, Input } from '@angular/core';
import { ControlContainer,FormGroupDirective, AbstractControl, Validators } from "@angular/forms";

@Component({
  selector: 'app-form-rating',
  templateUrl: './form-rating.component.html',
  styleUrls: ['./form-rating.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class FormRatingComponent implements OnInit {
  @Input() config: any;
  label: string | Array<{value: string, languageCode: string}> = '';
  activeColor: string = '#488aff';
  //default 5 selected stars 
  count: number = 5;
  selectedRating: number = 0;

  get control(): AbstractControl {
    return this.formGroupDirective.form.get(this.config.name);
  }
  constructor(private formGroupDirective: FormGroupDirective) { }

  ngOnInit() {
 
    if(this.config) {

      //set selected rating and number of stars according to count
      if(this.config.count) {
        //this.selectedRating = this.config.count;
        this.count = this.config.count;
      }

      if(this.config.label) {
        this.label = this.config.label;
      }
      //set min value validator only when isRequired 
      if(this.config.isRequired) {
          this.control.setValidators([Validators.min(1)]);
          //set field to invalid to disable submit button until field is touched
          this.control.setErrors({"incorrect": true})
        
      }
      if(this.config.activeColor) {
        this.activeColor = this.config.activeColor;
      }

    }
    
  }

  /**
   * onChange rating 
   * @author Radhika Agnihotri
   * @task QLIKTAG-3406
   */
  logRatingChange(newRating: number){
    //decrement rating when star is unselected
    if(newRating === this.selectedRating) {
      newRating = this.selectedRating - 1;
    }
    this.selectedRating = newRating;
    //manually set control value and mark touched and dirty
    if(this.control) {
      this.control.setValue(this.selectedRating.toString());
      this.control.markAsTouched();
      this.control.markAsDirty();
    }
  }
}
